import type { StatusChip } from "@itandi/itandi-bb-ui/StatusChip";
import type { ComponentProps } from "react";
import type {
	BuiltinWorkflowTag,
	ItandiTaskWorkflowStatus
} from "~/models/itandi_task/Workflow";
import {
	BUILTIN_WORKFLOW_TAG_SYSTEM_KEY,
	hasBuiltinWorkflowTag
} from "~/models/itandi_task/Workflow";

type CurrentStep = {
	name: string;
	taskId: number;
};

export type DealWorkflow = {
	applicantName: string;
	builtinWorkflowTags: BuiltinWorkflowTag[];
	createdAt: string;
	currentStep: CurrentStep | null;
	latestTaskComment: string | null;
	name: string;
	status: ItandiTaskWorkflowStatus;
	title: string;
	uuid: string;
};

export const isAfterTheFactApprovalWorkflow = (
	workflow: Pick<DealWorkflow, "builtinWorkflowTags">
): boolean =>
	hasBuiltinWorkflowTag(
		workflow.builtinWorkflowTags,
		BUILTIN_WORKFLOW_TAG_SYSTEM_KEY.AFTER_THE_FACT_APPROVAL
	);

export const DEAL_WORKFLOW_STATUS_CHIP = {
	canceled: { label: "中止", variant: "end" },
	completed: { label: "完了", variant: "success" },
	progress: { label: "進行中", variant: "info" }
} as const satisfies Record<
	ItandiTaskWorkflowStatus,
	{ label: string; variant: ComponentProps<typeof StatusChip>["variant"] }
>;
